export default "__VITE_ASSET__i7iBUWmr__"